<template>
  <div class="o-header__overlay">
    <div v-show="currentValue" class="o-header__overlay-text">
      <div>{{ $t('campaign.name') }} is nu</div>
      <div class="amount">€{{ formattedGeluidValue }}</div>
      <div>waard</div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useSignupStore } from '../store/signup'

const signupStore = useSignupStore()
const numberFormatter = new Intl.NumberFormat('nl-BE')

const currentValue = computed(() => signupStore.currentValue)
const formattedGeluidValue = computed(() => numberFormatter.format(currentValue.value))
</script>

<style lang="scss" scoped>
.o-header {
  &__overlay {
    --font-size: clamp(44px, 6cqh, 80px);
    position: relative;
  }

  &__overlay-text {
    font-weight: 600;
    margin-top: 10px;

    div {
      --c-secondary: var(--c-sunny-yellow);

      text-align: center;
      width: 100cqw;
      font-family: var(--font-title);
      letter-spacing: var(--letter-spacing-title);
      text-transform: var(--title-text-transform);
      color: var(--c-secondary);
      font-size: calc(0.7 * var(--font-size));
      line-height: calc(0.7 * var(--font-size));

      &.amount {
        --c-primary: white;
        color: var(--c-primary);
        font-family: var(--font-title);
        letter-spacing: var(--letter-spacing-title);
        text-transform: var(--title-text-transform);
        font-weight: 200;
        line-height: var(--font-size);
        font-size: var(--font-size);
        margin-top: 6px;
      }
    }
  }
}
</style>
